(function() {
  // Blog listing functionality
  function initListing() {
    const loadMoreBtn = document.querySelector('.js-blog-load');
    const articlesGrid = document.querySelector('.grid.grid-cols-2');
    
    if (!loadMoreBtn || !articlesGrid) return;

    loadMoreBtn.addEventListener('click', async () => {
      const currentPage = parseInt(loadMoreBtn.dataset.currentPage);
      const totalPages = parseInt(loadMoreBtn.dataset.totalPages);
      const blogUrl = loadMoreBtn.dataset.blogUrl;
      
      if (currentPage >= totalPages) {
        loadMoreBtn.style.display = 'none';
        return;
      }
      
      // Show loading state
      const originalText = loadMoreBtn.innerHTML;
      loadMoreBtn.innerHTML = 'Loading...';
      loadMoreBtn.disabled = true;
      
      try {
        const nextPage = currentPage + 1;
        const sectionId = 'main-blog';
        
        const response = await fetch(`${blogUrl}?page=${nextPage}`, {
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        });
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const html = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        
        // Find articles in the response
        const sectionContent = tempDiv.querySelector(`#shopify-section-${sectionId}`);
        let newArticles = sectionContent ? sectionContent.querySelectorAll('.article') : [];
        
        // Fallback: search for articles directly if not found in section
        if (newArticles.length === 0) {
          newArticles = tempDiv.querySelectorAll('.article');
        }
        
        if (newArticles.length > 0) {
          newArticles.forEach((article) => {
            articlesGrid.appendChild(article.cloneNode(true));
          });
          
          loadMoreBtn.dataset.currentPage = nextPage;
          
          if (nextPage >= totalPages) {
            loadMoreBtn.style.display = 'none';
          } else {
            loadMoreBtn.innerHTML = originalText;
            loadMoreBtn.disabled = false;
          }
        } else {
          loadMoreBtn.style.display = 'none';
        }
      } catch (error) {
        console.error('Error loading more articles:', error);
        loadMoreBtn.innerHTML = 'Error loading articles';
        setTimeout(() => {
          loadMoreBtn.innerHTML = originalText;
          loadMoreBtn.disabled = false;
        }, 2000);
      }
    });
  }

  // Search functionality
  function initSearch() {
    const searchInput = document.getElementById('blog-search-input');
    const regularArticles = document.getElementById('regular-articles');
    const searchResults = document.getElementById('search-results');
    const searchArticlesGrid = document.getElementById('search-articles-grid');
    const searchNoResults = document.getElementById('search-no-results');
    
    if (!searchInput || !regularArticles || !searchResults) return;

    let searchTimeout;
    
    // Toggle between regular articles and search results
    function showRegularArticles() {
      regularArticles.classList.remove('hidden');
      searchResults.classList.add('hidden');
    }
    
    function showSearchResults() {
      regularArticles.classList.add('hidden');
      searchResults.classList.remove('hidden');
    }
    
    // Truncate text to specified number of words
    function truncateWords(text, wordLimit) {
      if (!text) return '';
      // Strip HTML tags and get plain text
      const plainText = text.replace(/<[^>]*>/g, '').trim();
      if (!plainText) return '';
      const words = plainText.split(/\s+/);
      if (words.length <= wordLimit) return plainText;
      return words.slice(0, wordLimit).join(' ') + '...';
    }
    
    // Create article element for search results
    function createArticleElement(article) {
      const articleDiv = document.createElement('div');
      articleDiv.className = 'article';
      
      const excerptText = article.body || article.summary_html || '';
      const truncatedExcerpt = truncateWords(excerptText, 20);
      
      articleDiv.innerHTML = `
        <div>
          <div class="group relative">
            ${article.image ? `
              <div class="mb-3 md:mb-[1.25rem]">
                <div class="relative h-0 pb-[78%] bg-white">
                  <img
                    src="${article.image}"
                    alt="${article.title}"
                    class="motion-reduce absolute inset-0 object-cover object-center h-full w-full"
                    loading="lazy"
                    width="465"
                    height="365"
                  >
                </div>
              </div>
            ` : ''}
            <p class="font-heading mb-2 text-[0.9375rem] tracking-[0.3px] leading-[1.4]">${article.title}</p>
            ${truncatedExcerpt ? `<p class="mb-2">${truncatedExcerpt}</p>` : ''}
            <p class="mt-2 text-body-sm">
              <span>${new Date(article.published_at).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
            </p>
            <a href="${article.url}" class="absolute inset-0 w-full h-full">
              <span class="sr-only">${article.title}</span>
            </a>
          </div>
        </div>
      `;
      
      return articleDiv;
    }
    
    // Perform search using Shopify's predictive search API
    async function performSearch(query) {
      try {
        showSearchResults();
        searchNoResults.classList.add('hidden');
        searchArticlesGrid.innerHTML = '<div class="col-span-2 text-center py-8">Searching...</div>';
        
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=article&resources[limit]=10`);
        
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        
        const data = await response.json();
        const articles = data.resources?.results?.articles || [];
        
        searchArticlesGrid.innerHTML = '';
        
        if (articles.length > 0) {
          articles.forEach(article => {
            const articleElement = createArticleElement(article);
            searchArticlesGrid.appendChild(articleElement);
          });
          searchNoResults.classList.add('hidden');
        } else {
          searchNoResults.classList.remove('hidden');
        }
        
      } catch (error) {
        console.error('Error performing search:', error);
        searchArticlesGrid.innerHTML = '<div class="col-span-2 text-center py-8 text-red-500">Error searching articles. Please try again.</div>';
        searchNoResults.classList.add('hidden');
      }
    }
    
    // Handle search input
    searchInput.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
      
      if (query === '') {
        showRegularArticles();
        return;
      }
      
      searchTimeout = setTimeout(() => {
        performSearch(query);
      }, 300);
    });
  }

  function initPopularTopicsAccordion() {
    const accordions = document.querySelectorAll('[data-popular-topics]');
    if (!accordions.length) {
      return;
    }

    accordions.forEach((accordion) => {
      const plusIcon = accordion.querySelector('[data-popular-topics-icon-plus]');
      const minusIcon = accordion.querySelector('[data-popular-topics-icon-minus]');

      if (!plusIcon || !minusIcon) {
        return;
      }

      const updateIcons = (isOpen) => {
        const openState = typeof isOpen === 'boolean' ? isOpen : accordion.open;
        if (openState) {
          plusIcon.classList.add('hidden');
          minusIcon.classList.remove('hidden');
        } else {
          plusIcon.classList.remove('hidden');
          minusIcon.classList.add('hidden');
        }
      };

      updateIcons();

      const summary = accordion.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', () => {
          const nextState = !accordion.open;
          updateIcons(nextState);
        });
      }

      accordion.addEventListener('toggle', () => updateIcons());
    });
  }

  // Article video functionality
  function initArticleVideos() {
    const videoWrappers = document.querySelectorAll('[data-video-wrapper]');
    
    videoWrappers.forEach(wrapper => {
      const coverButton = wrapper.querySelector('[data-video-cover]');
      const video = wrapper.querySelector('[data-video]');
      
      if (coverButton && video) {
        coverButton.addEventListener('click', function() {
          coverButton.style.display = 'none';
          
          // Handle native video
          if (video.tagName === 'VIDEO') {
            video.play();
          } 
          // Handle YouTube iframe
          else if (video.tagName === 'IFRAME' && video.src.includes('youtube.com')) {
            const src = video.src;
            video.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
          }
          // Handle Vimeo iframe
          else if (video.tagName === 'IFRAME' && video.src.includes('vimeo.com')) {
            const src = video.src;
            video.src = src + (src.includes('?') ? '&' : '?') + 'autoplay=1';
          }
        });
        
        // Optional: Show cover again when native video ends
        if (video.tagName === 'VIDEO') {
          video.addEventListener('ended', function() {
            coverButton.style.display = 'block';
          });
        }
      }
    });
  }

  // Initialize everything when DOM is ready
  function initBlogListing() {
    initListing();
    initSearch();
    initPopularTopicsAccordion();
    initArticleVideos();
  }

  // Check if DOM is already loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlogListing);
  } else {
    initBlogListing();
  }

})();
